import { render, staticRenderFns } from "./rentTabs.vue?vue&type=template&id=6468632f&"
import script from "./rentTabs.vue?vue&type=script&lang=js&"
export * from "./rentTabs.vue?vue&type=script&lang=js&"
import style0 from "./rentTabs.vue?vue&type=style&index=0&sxoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports